package frontend.pages

import androidx.compose.runtime.*
import net.sergeych.ugdx.GuestAPI
import net.sergeych.ugdx.shared.*
import net.sergeych.ugdx.shared.api.*
import net.sergeych.ugdx.shared.trader.Trader
import com.ionspin.kotlin.bignum.decimal.BigDecimal
import com.ionspin.kotlin.bignum.decimal.toBigDecimal
import components.*
import frontend.App
import frontend.DepositContext
import frontend.lib.DateTimeDisplay
import frontend.lib.classList
import frontend.lib.displayCurrencyCode
import frontend.modals.*
import frontend.models.User
import kotlinx.coroutines.InternalCoroutinesApi
import kotlinx.coroutines.cancel
import kotlinx.coroutines.flow.collect
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import net.sergeych.mp_tools.globalLaunch
import org.jetbrains.compose.web.dom.*
import kotlin.time.Duration.Companion.hours

fun getAccountName(loginName: String?, accountId: Long?, accounts: List<ApiAccount>): String {
    if (loginName != null) return loginName
    if (accountId == null) return "You"

    val found = accounts.find { it.id == accountId }

    return found?.name ?: accountId.toString()
}

@Composable
fun Cell(content: @Composable () -> Unit = {}) {
    Td(attrs = { classList("px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900") }) {
        content()
    }
}

@Composable
fun CellRight(content: @Composable () -> Unit = {}) {
    Td(attrs = { classList("px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900") }) {
        content()
    }
}

@Composable
fun HeaderCell(content: @Composable () -> Unit = {}) {
    Th(attrs = {
        classList("px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider")
        attr("scope", "col")
    }) {
        content()
    }
}

enum class TransferType(val label: String) {
    LOCAL("Transfer between your accounts"),
    LOGIN("Transfer to other user")
}


@Composable
fun Account(
    app: App,
    user: User,
    account: ApiAccount,
    onChange: (() -> Unit)? = null
) {
    val scope = rememberCoroutineScope()
    var isTransferModalOpened by remember { mutableStateOf(false) }
    var isDepositModalOpened by remember { mutableStateOf(false) }
    var isBuyModalOpened by remember { mutableStateOf(false) }
    var isSellModalOpened by remember { mutableStateOf(false) }
    var isEditName by remember { mutableStateOf(false) }
    var name by mutableStateOf(account.name ?: account.id.toString())
    val currency = app.currencies.find { it.code == account.currencyCode }
    val zCurrency = app.currencies.find { it.code == "RY:ZYUZI" }

    fun deposit() {
        app.deposit = DepositContext(
            account,
            "",
            user.addresses.firstOrNull(),
            true
        )
    }

    fun testImport() {
        globalLaunch {
            currency?.let {
                val curr = it
                user.userAccount.testImport(it, BigDecimal.fromDouble(10_000.0))

                user.accounts.filter { it.currencyCode == curr.code }.forEach { acc ->
                    val updated = acc.refresh()
                    user.updateAccount(acc, updated)
                }
            }
//            user.loadAccounts()
        }
    }

    fun withdraw() {

    }

    fun buy() {
        isBuyModalOpened = true
    }

    fun sell() {
        isSellModalOpened = true
    }

    fun transfer() {
        isTransferModalOpened = true
    }

    fun showEditName() {
        name = account.name ?: ""
        isEditName = true
    }

    fun editName(newName: String) {
        scope.launch {
            val updated = account.update(newName, account.isDefault, account.isBrokerage)
//            user.updateAccount(account, updated)
            user.loadAccounts()
        }
    }

    fun setDefault() {
        scope.launch {
            val updated = account.update(account.name ?: "", !account.isDefault, account.isBrokerage)
//            user.updateAccount(account, updated)
            user.loadAccounts()
        }
    }

    fun setBrokerage() {
        scope.launch {
            val updated = account.update(account.name ?: "", account.isDefault, !account.isBrokerage)
//            user.updateAccount(account, updated)
            user.loadAccounts()
        }
    }

    Tr() {
        Cell { Text(displayCurrencyCode(account.currencyCode)) }
        Cell {
            if (!isEditName) {
                Button(attrs = {
                    onClick { showEditName() }
                    classList("px-3 py-2 mt-1")
                }) {
                    Text(name)
//                    if (name != "") Text("${account.currencyCode}: ${name}")
//                    else Text("${account.currencyCode}: ${account.id}")
                }
            } else {
                TTextInput("editName", name) {
                    onChange { editName(name) }
                    onInput { name = it }
                    onFocusOut { isEditName = false }

                    autoFocus()
                }
            }
        }
        Cell { Text(account.balance.toPlainString()) }
        Cell {
            TCheckbox("default", account.isDefault) {
                onChange { setDefault() }
            }
        }
        Cell {
            TCheckbox("default", account.isBrokerage) {
                onChange { setBrokerage() }
            }
        }
        Cell {
            currency?.let {
//                if (it.canExport) TLink("Deposit") { deposit() }
                if (it.code == "tDUST") {
                    TLink("Buy") { buy() }
                    Br()
                    TLink("Sell") { sell() }
                    Br()
                } else if (it.canExport) {
//                    TLink("Deposit") { deposit() }
//                    Br()
                }
                if (it.code != "tDUST") {
                    if (it.realm == Currency.Realm.TEST) {
                        TLink("Test import") { testImport() }
                    }
                }
            }
        }
        Cell {
            currency?.let {
                if (it.code != "tDUST") {
                    if (it.canExport) TLink("Withdraw") { withdraw() }
                }
            }
        }
        Cell { TLink("Transfer") { transfer() } }
        Cell { TLink("Details") { app.router.dispatch("/wallet/${account.id.toString()}") } }
        Cell {
//            if (account.balance == BigDecimal.ZERO) TButton(attrs = {
//                color(ButtonColor.Red)
//                size(ButtonSize.sm)
//                onClick {
//                    scope.launch { user.deleteAccount(account) }
//                }
//            }) { TrashIcon("h-5 w-5") }
            TButton(attrs = {
                color(ButtonColor.Red)
                size(ButtonSize.sm)
                onClick {
                    scope.launch { user.deleteAccount(account) }
                }
            }) { TrashIcon("h-5 w-5") }

//            TButton(attrs = {
//                color(ButtonColor.Yellow)
//                size(ButtonSize.sm)
//                onClick {
//                    scope.launch {
//                        val currency = app.currencies.find { it.code == account.currencyCode }
//                        currency?.let {
//                            wallet.user.userAccount.testImport(it, "1000.0".toBigDecimal())
//                        }
//                    }
//                }
//            }) { Text("i") }
        }
    }

    if (isTransferModalOpened) TransferModal(user, account) {
        scope.launch {
//            val updated = account.refresh()
//            user.updateAccount(account, updated)
            user.loadAccounts()
            isTransferModalOpened = false
        }
    }
    if (isBuyModalOpened) zCurrency?.let {
        BuyDUSTModal(app, user, it, account) {
            scope.launch {
//                val updated = account.refresh()
//                user.updateAccount(account, updated)
                user.loadAccounts()
                isBuyModalOpened = false
            }
        }
    }
    if (isSellModalOpened) zCurrency?.let {
        SellDUSTModal(app, user, it, account) {
            scope.launch {
//                val updated = account.refresh()
//                user.updateAccount(account, updated)
                user.loadAccounts()
                isSellModalOpened = false
            }
        }
    }

    if (app.deposit?.isOpen != false) DepositModal(app, user, account) {
        scope.launch {
            val updated = account.refresh()
            user.updateAccount(account, updated)
            app.deposit?.let { app.deposit = it.copy(isOpen = false) }
        }
    }
}


@Composable
fun Accounts(app: App, user: User) {
    val scope = rememberCoroutineScope()

    var isCreationModalOpen: Boolean by remember { mutableStateOf(false) }

    fun createAccount() { isCreationModalOpen = true }

    var dustzai = app.pairs.find { it.base.code == "tDUST" && it.quote.code == "RY:ZYUZI"}

    LaunchedEffect(true) {
        dustzai?.let {
            val x = Trader.orderbookFor(it)
            x.onEach {
                println("GOT DUST / ZAI DOM INFO")
                val order = it?.orders?.filter { it.isBuy == true }?.sortedBy { it.amount }?.lastOrNull()
                order?.let {
                    println("ORDER LIMIT ${order.limit}")
                    app.dustzaiBid = order.limit
                    this.cancel()
                }
            }.collect()
        }
    }

    H3(attrs = { classList("text-lg leading-6 font-medium text-gray-900") }) {
        Text("Accounts")
    }

    P(attrs = { classList("mt-1 max-w-2xl text-sm text-gray-500") }) {
        TLink("Refresh") { scope.launch { user.load() } }
    }

    if (user.accounts.isEmpty()) {
        P(attrs = { classList("mt-1 max-w-2xl text-sm text-gray-500") }) {
            Text("You have no accounts yet. ")
            A("javascript:void(0);", attrs = {
                classes("font-medium", "text-indigo-600", "hover:text-indigo-500")
                onClick { createAccount() }
            }) {
                Text("Create one")
            }
        }
    } else {
        Table(attrs = { classList("min-w-full divide-y divide-gray-200 mt-2") }) {
            Thead(attrs = { classList("bg-gray-50") }) {
                Tr() {
                    HeaderCell { Text("Currency") }
                    HeaderCell { Text("Name") }
                    HeaderCell { Text("Balance") }
                    HeaderCell { Text("Default") }
                    HeaderCell { Text("Market") }
                    HeaderCell {}
                    HeaderCell {}
                    HeaderCell {}
                    HeaderCell {}
                    HeaderCell {}
                }
            }

            Tbody {
                user.accounts.sortedBy { it.currencyCode }.forEach { Account(app, user, it) }

                Tr() {
                    Td(attrs = { classList("px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900") }) {
                        A("javascript:void(0);", attrs = {
                            classes("font-medium", "text-indigo-600", "hover:text-indigo-500")
                            onClick { createAccount() }
                        }) {
                            Text("Create account")
                        }
                    }
                }
            }
        }
    }

    if (isCreationModalOpen) CreateAccountModal(app, user) { isCreationModalOpen = false }
}


@Composable
fun Operation(app: App, user: User, operation: ApiOperation) {
    val accounts = user.accounts
    val fromAccountName = getAccountName(operation.fromLoginName, operation.fromAccountId, accounts)
    val toAccountName = getAccountName(operation.toLoginName, operation.toAccountId, accounts)
    val createdAt = DateTimeDisplay(operation.createdAt)

    Tr {
        Cell { Text(operation.type.toString()) }
        Td(attrs = { classList("px-6 py-4 text-right whitespace-nowrap text-sm text-gray-900") }) {
            Text(fromAccountName)
        }
        Cell { Text(toAccountName) }
        Cell { P { Text(operation.purpose) } }
        Cell {
            P {
                Span(attrs = { classList("text-gray-500") }) { Text("Operation ID: ") }
                Text(operation.id.toString())
            }
            P {
                Span(attrs = { classList("text-gray-500") }) { Text("Referred ID: ") }
                Text(operation.referredOperationId?.toString() ?: "")
            }
            operation.orderId?.let {
                P {
                    TLink("Order ID $it") { app.router.dispatch("/orders/$it") }
                }
            }
        }
        Td(attrs = { classList("px-6 py-4 text-right whitespace-nowrap text-sm text-gray-900") }) {
            Text(createdAt)
        }
    }
}


@Composable
fun OperationsList(app: App, user: User, operations: List<ApiOperation>) {
    Table(attrs = { classList("min-w-full divide-y divide-gray-200 mt-2") }) {
        Thead(attrs = { classList("bg-gray-50") }) {
            Tr() {
                HeaderCell { Text("Type") }
                Th(attrs = { classList("px-6 py-3 bg-gray-50 text-right text-xs font-medium text-gray-500 uppercase tracking-wider") }) {
                    Text("From")
                }
                HeaderCell { Text("To") }
                HeaderCell { Text("Purpose")}
                HeaderCell { Text("System info") }
                Th(attrs = { classList("px-6 py-3 bg-gray-50 text-right text-xs font-medium text-gray-500 uppercase tracking-wider") }) {
                    Text("Created at")
                }
            }
        }

        Tbody(attrs = {
            classList("bg-white divide-y divide-gray-200")
        }) {
            operations.reversed().forEach { Operation(app, user, it) }
        }
    }
}


@Composable
fun AccountUI(app: App, user: User, account: ApiAccount) {
    val scope = rememberCoroutineScope()
    val now = Clock.System.now()
    var fromDate: Instant by remember { mutableStateOf(now - 24.hours) }
    var toDate: Instant by remember { mutableStateOf(now) }
    var operations: List<ApiOperation> by remember { mutableStateOf(emptyList()) }
    var isLoading: Boolean by mutableStateOf(false)
    var isMounted: Boolean by remember { mutableStateOf(false) }
    var error: String? by remember { mutableStateOf(null) }

    fun updateOperations(fromDate: Instant, toDate: Instant) {
        scope.launch {
            try {
                println(fromDate)
                println(toDate)
                operations = account.operations(fromDate, toDate)
                error = null
            } catch (err: ApiException) {
                println(err)
                error = err.message
            }
        }
    }

    if (!isMounted) {
        isMounted = true
        updateOperations(fromDate, toDate)
    }

    H3(attrs = { classList("text-lg leading-6 font-medium text-gray-900") }) {
        Text(account.name ?: account.id.toString())
    }

    P(attrs = { classList("mt-1 max-w-2xl text-sm text-gray-500") }) {
        TLink("Back to accounts") { app.router.dispatch("/wallet") }
    }

    DatepickerRange {
        From {
            onChange {
                it?.let {
                    val shouldUpdate = fromDate != it
                    fromDate = it
                    if (shouldUpdate) updateOperations(fromDate, toDate)
                }
            }
            value(fromDate)
        }

        To {
            onChange {
                it?.let {
                    val shouldUpdate = toDate != it
                    toDate = it
                    if (shouldUpdate) updateOperations(fromDate, toDate)
                }
            }
            value(toDate)
        }
    }
    error?.let { Text(it) }
    OperationsList(app, user, operations)

}

class Wallet(val user: User, val currencies: List<Currency>) {
    var selectedAccount: ApiAccount? by mutableStateOf(null)
    var isLoading: Boolean by mutableStateOf(true)

    suspend fun load() {
        isLoading = true
        user.load()
        isLoading = false
    }
}


@Composable
fun WalletScreenUI(app: App, user: User, params: MatchResult? = null) {
    var accountId = params?.destructured?.component1()
    var account = user.accounts.find { it.id.toString() == accountId }

    RoundedContainer() {
//        account?.let { AccountUI(app, user, it) }
        if (account != null)  AccountUI(app, user, account)
        else Accounts(app, user)
    }

//    val wallet = remember { Wallet(user, app.currencies) }
//    var selectedAccount: ApiAccount? = null

//    LaunchedEffect(true) { wallet.load() }

//    if (params != null) {
//        var (accountIdParam) = params.destructured
//        selectedAccount = user.accounts.find { it.id.toString() == accountIdParam }
//    }

//    if (!wallet.isLoading) RoundedContainer() {
//        wallet.selectedAccount?.let { AccountUI(app, wallet, it) }
//        if (wallet.selectedAccount == null) {
//            Accounts(app, wallet)
//        }
//    }
}
